<template xmlns:v-bind="http://www.w3.org/1999/xhtml" xmlns:v-on="http://www.w3.org/1999/xhtml">
    <div class="login-bg-main-section register-main-section width-full float-l" id="login-main-hr">
        <div v-if="currentEnvironment" class="notification-block notification-block-top">
            <div role="alert" aria-live="polite" aria-atomic="true" class="alert alert-primary alert-dismissible">
                <div class="scroll-left">
                    <p>This is Test Environment !</p>
                </div>
            </div>
        </div>
        <div class="login-left-section float-l"> <!--left section-->
            <router-link v-bind:to="{ path:'/'}"> <img src="/static/images/vvg-home-logo.png" alt="Velocity Truck Center"> </router-link>
        </div> <!--left section-->
        <div class="register-right-main-section width-full float-l"> <!--right section-->
            <form class="cmxform" @submit.prevent="attemptResetPassword();" id="ResetPasswordCustomerForm" name="form">

                <div class="register-form-main">
                    <h2> Reset Password </h2>
                    <div class="row">
                        <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-offset-0 col-sm-offset-3 col-md-offset-3 col-lg-offset-3">
                            <label for="pwd">Password<span class="text-danger">*</span></label>
                            <input id="password" type="password" placeholder="" name="pwd" required v-model="password">
                            <font class="text-danger">{{frontendErrors.password}}</font>
                        </div>
                        <div class="clearfix"></div>

                        <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-offset-0 col-sm-offset-3 col-md-offset-3 col-lg-offset-3">
                            <label for="cpwd">Confirm Password<span class="text-danger">*</span></label>
                            <input id="cpassword" type="password" placeholder="" name="cpwd" required v-model="cpassword">
                            <font class="text-danger">{{frontendErrors.cpassword}}</font>
                        </div>                        
                        <div class="clearfix"></div>

                        <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-offset-0 col-sm-offset-3 col-md-offset-3 col-lg-offset-3">
                            <font class="text-danger"> <label id="errorMsg" class="error text-danger"></label><br> </font>
                        </div>

                        <div class="btm-login-section btm-register-section col-12 float-l">
                            <div class="btn-login-main float-l col-12 col-sm-6 col-md-6 col-lg-6 col-offset-0 col-sm-offset-3 col-md-offset-3 col-lg-offset-3">
                                <div class="row">  
                                    <button class="hvr-sweep-to-right-red" id="sendEmail">Submit</button>
                                    <button type="button" class="hvr-sweep-to-right-red" v-on:click.prevent="backBtn()">Back</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </div> <!--right section-->
    </div>
</template>

<script>
    import EventBus from './event-bus';
    import {loginUrl, configs} from '../config';
    import SessioMixin from '../mixins/sessionmixin';
    var self;
    import {HTTP} from '../http-common';
    //import Autocomplete from 'vuejs-auto-complete'
    import Vue from 'vue';
    export default {
        name: 'ResetPassword',
        props: [''],
        components: {},
        mixins: [SessioMixin],
        data() {
            return {
                userToekn: '',
                password: '',
                cpassword: '',
                frontendErrors: {
                    password: '',
                    cpassword: '',
                },
                idetify_flag: "",
            }
        },
        mounted: function () {
            self = this;
            self.getBuildVersion();
            $('#main-header').hide();
            $('#main-footer').hide();
            $('html,body,#app').css({
                //height: "100%"
            });
            $("#login-main-hr").height($(window).height());
            $("#password").on('keyup', function () {
                self.frontendErrors.password = '';
            });
            $("#cpassword").on('keyup', function () {
                self.frontendErrors.cpassword = '';
            });
            self.userToekn = this.$route.params.token;
            self.idetify_flag = self.$route.query.idetify;
            //console.log(self.userToekn);
            setTimeout(function () {
                $('#password').val('');
            }, 500);

        },
        methods: {
            backBtn: function () {
                switch (self.idetify_flag) {
                    case 'hrportal':
                        self.$router.push('/login');
                        break;
                    default :
                        window.location.replace(self.idetify_flag);
                }
                /*if(self.idetify_flag == 'salesintranet') {
                 window.location.replace(process.env.SALESINTRANET_URL);
                 } else {
                 self.$router.push('/login');
                 }*/
            },
            checkForm: function () {
                var checked = true;
                self.frontendErrors.password = "";
                self.frontendErrors.cpassword = "";

                if (!self.password) {
                    self.frontendErrors.password = 'Password Required';
                    if (checked) {
                        checked = false;
                    }
                }
                if (!self.cpassword) {
                    self.frontendErrors.cpassword = 'Confirm Required';
                    if (checked) {
                        checked = false;
                    }
                }
                if (self.password != self.cpassword) {
                    self.frontendErrors.cpassword = 'Password Does Not Match';
                    if (checked) {
                        checked = false;
                    }
                }
                return checked;
            },
            attemptResetPassword() {
                self.checkForm();
                if (self.checkForm()) {
                    $('#sendEmail').html('Submiting...');
                    $('#sendEmail').prop('disabled', true);
                    var fields = {
                        token: self.userToekn,
                        password: self.password,
                    };
                    HTTP.post("/forgot/password", fields)
                            .then(function (response) {
                                $('#sendEmail').html('Submit');
                                $('#sendEmail').prop('disabled', false);
                                if (response.data.status == "success") {
                                    self.backBtn();
                                }
                                if (response.data.code != 200) {
                                    $('#errorMsg').html(response.data.message);
                                }
                            })
                            .catch(function (err) {
                                $('#sendEmail').html('Submit');
                                $('#sendEmail').prop('disabled', false);
                                if (err.response.status == 0) {
                                    self.error = "Remote server can not be reachable";
                                } else {
                                    $('#errorMsg').html(err.response.data.message);
                                }
                            });
                }

                //
            }
        }

    }
</script>


// WEBPACK FOOTER //
// src/components/ResetPassword.vue